import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-create-directory',
  templateUrl: './create-directory.component.html',
  styleUrls: ['./create-directory.component.scss']
})
export class CreateDirectoryComponent implements OnInit {

  createDirectoryForm: UntypedFormGroup;
  showSpaceWarning = false;

  constructor(
    public dialog: MatDialogRef<CreateDirectoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(){
    this.createDirectoryForm = new UntypedFormGroup({
      directoryName: new UntypedFormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9@_. -]*$/)])
    })

    this.createDirectoryForm.get('directoryName').valueChanges.subscribe(value => {
      this.showSpaceWarning = value && value.includes(' ');
    });
  }

  onSubmit(form){
    if(form.status == 'INVALID'){
      form.controls.directoryName.touched = true;
    } else {
      this.dialog.close(form.value.directoryName)
    }
  }

  onClose() {
    this.dialog.close(false)
  }
}
